import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, model } from '@angular/core';
import { ButtonComponent } from 'src/app/shared/components/button/button.component';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';

@Component({
  selector: 'z-about-dialog',
  standalone: true,
  imports: [CommonModule, DialogComponent, ButtonComponent],
  templateUrl: './about-dialog.component.html',
  styleUrl: './about-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AboutDialogComponent {
  isAboutDialogVisible = model.required<boolean>();
  currentYear = new Date().getFullYear();
  handleDialogClose() {
    this.isAboutDialogVisible.set(false);
  }
}
